import lotsAddressCascader from './index.vue'; // 导入组件

lotsAddressCascader.install = (Vue) => {
    Vue.component(lotsAddressCascader.name, lotsAddressCascader);
};
export default lotsAddressCascader;
